/**
 * Convenience function for creating HTMLElements.
 * @param {string} tag - Tag name (e.g. 'div')
 * @param {object} attributes - Any attributes/properties.
 * @param {...any} children - Children to be directly appended.
 */
export function createElement(tag, attributes = {}, ...children) {
	const el = document.createElement(tag)

	// Apply attributes etc.
	for (const [key, value] of Object.entries(attributes)) {
		if (key === 'style') {
			for (const [property, val] of Object.entries(value)) {
				el.style[property] = val
			}
		}
		else if (key === 'class' || key === 'classname' || key === 'className') {
			el.className = value
		}
		else if (/^on[A-Z]/.test(key)) {
			el.addEventListener(key.substr(2).toLowerCase(), value)
		}
		else {
			el[key] = value
		}
	}

	// Append any child (recursively).
	function addChildNode(node, level = 0) {
		if (node === false || node === undefined || node === null) {
			return
		}
		if (Array.isArray(node)) {
			node.forEach(child => addChildNode(child, level + 1))
		}
		else if (node instanceof HTMLElement) {
			el.appendChild(node)
		}
		else {
			const text = document.createTextNode(node)
			el.appendChild(text)
		}
	}

	for (const child of children) {
		addChildNode(child)
	}

	return el
}